// modules
import { createAction } from 'redux-actions'

// actions
export const setBroadcastMessageValues = createAction(
  'SET_BROADCAST_MESSAGE_VALUES'
)
export const setBroadcastMessageList = createAction(
  'SET_BROADCAST_MESSAGE_LIST'
)
export const setBroadcastMessageListProps = createAction(
  'SET_BROADCAST_MESSAGE_LIST_PROPS'
)

export const setBroadcastValues = createAction('SET_BROADCAST_VALUES')
export const setBroadcastList = createAction('SET_BROADCAST_LIST')

export const setBroadcastPatientList = createAction(
  'SET_BROADCAST_PATIENT_LIST'
)

export const resetBroadcast = createAction('RESET_BROADCAST')
